import { ChangeEvent, FC } from 'react';
import { Checkbox } from '@doda/io-react/common';
import { PrefectureDrillDownType } from '../types';
import styles from './index.module.scss';
import { DrillDownText } from '../../DrillDownText';

/**
 * Propsの型定義
 * @param drillDown ドリルダウン
 * @param onChange チェックボックス更新処理
 */
interface Props {
  drillDown: Omit<PrefectureDrillDownType, 'type'>;
  onChange: (event: ChangeEvent<HTMLInputElement>, selectedId: string) => void;
}

export const PrefectureDrillDown: FC<Props> = ({ drillDown, onChange }) => {
  const { title, jobCount, prefectures } = drillDown;

  return (
    <div>
      <DrillDownText title={title} jobCount={jobCount} size="L" />
      <ul>
        {prefectures.map((prefecture) => (
          <li
            key={prefecture.id}
            className={styles.prefectureDrillDown__checkbox}
          >
            <Checkbox
              value={prefecture.id}
              checked={prefecture.isChecked}
              label={
                <DrillDownText
                  title={prefecture.title}
                  jobCount={prefecture.jobCount}
                  url={prefecture.url}
                  isBold={prefecture.isBold}
                  size="L"
                />
              }
              onChange={(event) => {
                if (prefecture.url) {
                  onChange(event, prefecture.id);
                }
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
